/*
 * View for the content topics
 */

define(["marionette", "./template/contentTopicsTemplate.html"], function (
  Marionette,
  ContentTopicsTemplate,
) {
  var ContentTopicsView = {};

  ContentTopicsView.contentTopicsLayout = Marionette.Layout.extend({
    template: ContentTopicsTemplate,
    regions: {
      contentTopicsList: "#contentTopicList",
    },
  });

  return ContentTopicsView;
});
